export default "__VITE_ASSET__BppMtf3x__"